import React from 'react';
import PT from 'prop-types';
import TranslatorManager from 'ts-translate-js';
import tsRest from 'ts-rest-client';
import { map, filter, includes } from 'lodash';
import { Button, Textbox } from '../toolkit';

const tr = TranslatorManager.boundTR;

const ERR_REQUIRED = 'REQUIRED';
const ERR_NOT_IDENTICAL = 'NOT_IDENTICAL';
const ERR_PWD_LENGTH = 'INVALID_PWD_LENGTH';

export class EmailPasswordModification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newPassword: "",
            passwordConfirmation: "",
            errors: [],
            hasValidationErrors: false,
            hasCompletionErrors: false,
            isSuccess: false,
            memberId: this.props.memberId
        };
    }

    onInputChange(field, value) {
        this.setState({[field]: value});
    }

    async onButtonClicked() {
        if (this.state.isSuccess) {
            window.location.href = "/";
        } else {
            await this.updatePassword();
        }
    }

    async updatePassword() {
        try {
            await tsRest.post("/profile/emailpasswordmodification", this.state);
            this.setState({isSuccess: true});
        }
        catch(err) {
            const isInValidationStep = err.body.FieldValidationErrors != null;
            const errors =  isInValidationStep ? err.body.FieldValidationErrors : err.body.Message;
            this.setState({errors: errors, hasValidationErrors: isInValidationStep, hasCompletionErrors: !isInValidationStep});    
        }

        this.setState({newPassword: "", passwordConfirmation: ""});
    }

    parseValidationErrors() {
        if (this.state.hasValidationErrors) {
            const newPasswordErrors = map(filter(this.state.errors, {"FieldName": "newPassword"}), "ErrorName");
            const passwordConfirmationErrors = map(filter(this.state.errors, {"FieldName": "passwordConfirmation"}), "ErrorName");
            return [newPasswordErrors, passwordConfirmationErrors];
        }
    }

    createNewPasswordErrorMessage(newPasswordErrors) {
        if (includes(newPasswordErrors, ERR_REQUIRED)) {
            return (
                <div className="has-error">
                    <span className="help-block">{tr("Requis")}</span>
                </div>
            );
        }
        if (includes(newPasswordErrors, ERR_PWD_LENGTH)) {
            return (
                <div className="has-error">
                    <span className="help-block">{tr("Le mot de passe doit comprendre entre 5 et 25 caractères")}</span>
                </div>
            );
        }
    }

    createPasswordConfirmationErrorMessage(passwordConfirmationErrors) {
        if (includes(passwordConfirmationErrors, ERR_REQUIRED)) {
            return (
                <div className="has-error">
                    <span className="help-block">{tr("Requis")}</span>
                </div>
            );
        }
        if (includes(passwordConfirmationErrors, ERR_NOT_IDENTICAL)) {
            return (
                <div className="has-error">
                    <span className="help-block">{tr("La confirmation du mot de passe doit être identique au nouveau")}</span>
                </div>
            );
        }
    }

    createCompletionErrorMessage(errors) {
        if (errors === "PWD_ALREADY_MODIFIED") {
            return (
                <div className="has-error alert alert-danger">
                    <span className="help-block">{tr("Vous avez déjà modifié votre mot de passe.")}</span>
                </div>
            );
        }
        if (errors === "ERROR") {
            return (
                <div className="has-error alert alert-danger">
                    <span className="help-block">{tr("Une erreur est survenue. Veuillez réessayer.")}</span>
                </div>
            );
        }
    }

    createSuccessMessage() {
        return (
            <div className="has-success alert alert-success">
                <span className="help-block">{tr("Votre mot de passe a bien été changé.")}</span>
            </div>
        );
    }

    render() {
        let newPasswordErrors, passwordConfirmationErrors, 
            newPasswordErrorMessage, passwordConfirmationErrorMessage, completionErrorMessage,
            successMessage = null;

        if (this.state.hasValidationErrors) {
            [newPasswordErrors, passwordConfirmationErrors] = this.parseValidationErrors();
            newPasswordErrorMessage = this.createNewPasswordErrorMessage(newPasswordErrors);
            passwordConfirmationErrorMessage = this.createPasswordConfirmationErrorMessage(passwordConfirmationErrors);
        } else if (this.state.hasCompletionErrors) {
            completionErrorMessage = this.createCompletionErrorMessage(this.state.errors);
        }

        if (this.state.isSuccess) {
            successMessage = this.createSuccessMessage();
        }

        const buttonTitle = this.state.isSuccess ? tr("Retourner à l'accueil") : tr("Modifier");
        return (
            <div>
                <h2>{tr("Réinitialisation de votre mot de passe")}</h2>
                <div className="content-text">
                    <Textbox
                        id="new-password"
                        type="password"
                        placeholder={tr("Nouveau mot de passe")}
                        value={this.state.newPassword}
                        onChange={this.onInputChange.bind(this, "newPassword")}
                        errorMessage={newPasswordErrorMessage}
                        isInvalid={this.state.hasValidationErrors || this.state.hasCompletionErrors}
                    />
                    <div className="spacer-row"></div>
                    <Textbox
                        id="password-confirmation"
                        type="password"
                        placeholder={tr("Confirmation du nouveau mot de passe")}
                        value={this.state.passwordConfirmation}
                        onChange={this.onInputChange.bind(this, "passwordConfirmation")}
                        errorMessage={passwordConfirmationErrorMessage}
                        isInvalid={this.state.hasValidationErrors || this.state.hasCompletionErrors}
                    />
                    {completionErrorMessage}
                    {successMessage}
                    <div className="spacer-row"></div>
                    <Button
                        id="btn-update-password"
                        isLarge={this.state.isSuccess}
                        useSmallerFontSize={this.state.isSuccess}
                        onButtonClicked={this.onButtonClicked.bind(this)} 
                    >
                        <span>{buttonTitle}</span>
                    </Button>
                </div>
            </div>
        );
    }
}
EmailPasswordModification.propTypes = {
    memberId: PT.string
};